// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"145":"910d79a1","262":"27831960"}[chunkId] + ".js";
};